import getMessage from 'src/background/utils/i18n.utils';
import { addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { VestinRouteItemComponent } from '@popup/steem/pages/app-container/vesting-routes-popup/vesting-route-item/vesting-route-item.component';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { LoadingComponent } from 'src/common-ui/loading/loading.component';
import { PopupContainer } from 'src/common-ui/popup-container/popup-container.component';
const VestingRoutesPopup = ({ vestingRoutesDifferences, closePopup, loadingState, }) => {
    const [pageIndex, setPageIndex] = useState(0);
    const nextCarouselSlide = () => {
        setPageIndex(pageIndex + 1);
    };
    return (React.createElement(PopupContainer, { className: "vesting-routes-popup" },
        React.createElement(LoadingComponent, { hide: !loadingState.loadingOperations.length, operations: loadingState.loadingOperations }),
        React.createElement("div", { className: "popup-title" }, getMessage('popup_html_vesting_routes_title')),
        React.createElement("div", { className: "caption", dangerouslySetInnerHTML: {
                __html: getMessage('popup_html_vesting_routes_warning_message'),
            } }),
        React.createElement(Carousel, { showArrows: false, showIndicators: false, selectedItem: pageIndex, showThumbs: false, showStatus: false, dynamicHeight: true }, vestingRoutesDifferences.map(({ account, differences }) => {
            return (React.createElement(VestinRouteItemComponent, { key: `vesting-route-item-${account}`, account: account, differences: differences, nextCarouselSlide: nextCarouselSlide, isLast: pageIndex === vestingRoutesDifferences.length - 1, clearDisplayWrongVestingRoutes: closePopup }));
        }))));
};
const mapStateToProps = (state) => {
    return {
        loadingState: state.loading,
    };
};
const connector = connect(mapStateToProps, {
    addToLoadingList,
    removeFromLoadingList,
});
export const VestingRoutesPopupComponent = connector(VestingRoutesPopup);
